export default __webpack_public_path__ + "static/process-02-a7fe25f14bb483da5f2ddceeb29b5d30.svg";